<template>
 <div>
        <img
                  @click="
                    openInNewTab(
                      'https://www.maxwhitlockgymnastics.co.uk/'
                    )
                  "
                  class="w-full pl-2"
                  src="/static/images/maxw.png"
                  alt=""
                />

                <div class="p-5">
                  <h5
                    class="mb-2 text-lg font-bold tracking-tight text-gray-700 dark:text-white"
                  >
                    Max Whitlock Gymnastics
                  </h5>

                  <div
                    class="mb-3 font-normal text-gray-700 dark:text-gray-400"
                  >
                    <p>
                        Revolutionising gymnastics in Primary Education: Tailored CPD and rich resources for unleashing every child's potential.
                    </p>
                  
                  </div>

                  <div
                    @click="
                      openInNewTab(
                        'https://www.maxwhitlockgymnastics.co.uk/'
                      )
                    "
                    class="link cursor-pointer focus:ring-4 focus:outline-none focus:ring-blue-300"
                  >
                    Read more (external link)
                    <i
                      class="fas fa-caret-right ml-3 text-base text-action-blue"
                    ></i>
                  </div>
                  <br />

                  <div
                    @click="
                      openInNewTab('https://shop.primarypepassport.co.uk/')
                    "
                    class="link cursor-pointer text-green-600 focus:ring-4 focus:outline-none focus:ring-blue-300"
                  >
                    Purchase add on curriculum (external link)
                    <i
                      class="fas fa-caret-right ml-3 text-base text-action-blue"
                    ></i>
                  </div>
                </div>
    </div>
</template>
<script>
    export default{
        name: "AdvertMaxW",

        methods: {

openInNewTab(url) {
  window.open(url, '_blank');
},
},
    }

</script>
<style scoped>

</style>